module.exports = __webpack_public_path__ + "img/bg.6e732bb7.jpeg";